import { assign } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';

export const getCartFailure = assign(
  (
    context: ProductBuilderMachineContext,
    event: ProductBuilderMachineEvent,
  ) => {
    console.log('getCart has failed');
    console.log(event);
    return context;
  },
);
